import { useNavigate } from "@tanstack/react-router";

import { useCreateWaterSource } from "@/lib/api/water-sources";
import { newULID } from "@/lib/api/client";
import { ErrorState } from "@/components/error-state";

import {
  WaterSourceForm,
  emptyToUndef,
  parseOptNum,
  type WaterSourceFormValues,
} from "./form";

export function WaterSourceNewPage() {
  const navigate = useNavigate();
  const create = useCreateWaterSource();

  function submit(values: WaterSourceFormValues) {
    create.mutate(
      {
        id: newULID(),
        name: values.name,
        baseline_ph: parseOptNum(values.baseline_ph),
        baseline_ec: parseOptNum(values.baseline_ec),
        alkalinity_estimate: parseOptNum(values.alkalinity_estimate),
        notes: emptyToUndef(values.notes),
      },
      {
        onSuccess: () => navigate({ to: "/chemistry-profile" }),
      },
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">New water source</h1>
      <WaterSourceForm
        submitting={create.isPending}
        onSubmit={submit}
        submitLabel="Create"
        banner={
          create.error ? (
            <ErrorState error={create.error} retry={() => create.reset()} />
          ) : undefined
        }
      />
    </div>
  );
}
